import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueMoment from "vue-moment";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

export const bus = new Vue({
  router,
  vuetify,
  render: h => h(App)
});

bus.$mount("#app");

Vue.use(VueMoment);
